import { TypeFlux } from "../utils/enumeration";

export class ModeTransport {
    typeFluxAerien: TypeFlux;
    typeFluxMaritime: TypeFlux;

    constructor(){
        this.typeFluxAerien = null;
        this.typeFluxMaritime = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/classes/modeTransport.ts